<hw-page-header header="{{ 'pechkin.test-01.header-sms' | translate }}" class="page-header">
  <div class="content float-right">
    <button type="button" class="button" nz-button nzType="primary" (click)="send()" [disabled]="!form.valid">
      {{ 'pechkin.test-01.btn.send' | translate }}
    </button>
  </div>
</hw-page-header>
<nz-content class="main">
  <form nz-form [formGroup]="form" novalidate>
    <hw-form-row>
      <hw-form-item
        name="receivers"
        [required]="true"
        label="{{ 'pechkin.test-01.label.receiver' | translate }}"
        *hwFormCol>
        <nz-input-group nzAddOnBefore="+372">
          <input nz-input type="text" formControlName="receiver" />
        </nz-input-group>
      </hw-form-item>
    </hw-form-row>
    <hw-form-row>
      <hw-form-item name="template" label="{{ 'pechkin.test-01.label.template' | translate }}" *hwFormCol>
        <nz-select formControlName="template" (ngModelChange)="templateChange($event)">
          <nz-option *ngFor="let t of templates" [nzValue]="t" [nzLabel]="t.names | localName"></nz-option>
        </nz-select>
      </hw-form-item>
    </hw-form-row>
    <hw-form-row>
      <hw-form-item
        name="message"
        [required]="true"
        label="{{ 'pechkin.test-01.label.message' | translate }}"
        *hwFormCol>
        <textarea nz-input formControlName="message" [nzAutosize]="{ minRows: 2, maxRows: 8 }"> </textarea>
      </hw-form-item>
    </hw-form-row>
  </form>
</nz-content>
